import * as PaymentAction from './payment.actions';
import {Price} from '../price.model';

export interface State {
  pricing: Price[];
  pricingProfile: Price[];
  pricingTime: any[];
  price: Price;
  paymentDetail: any;
  paymentLoader: any;
}

const initialState: State = {
  pricing: [],
  pricingProfile: [],
  pricingTime: [],
  price: null,
  paymentDetail: null,
  paymentLoader: {
    pay: false,
    loadingPricing: false
  }
};

export function paymentReducer(state = initialState, action: PaymentAction.PaymentActions) {
  switch (action.type) {
    case PaymentAction.SET_PRICE:
      return {
        ...state,
        price: action.payload
      };
    case PaymentAction.SET_PRICING:
      return {
        ...state,
        pricing: action.payload
      };
    case PaymentAction.SET_PRICING_PROFILE:
      return {
        ...state,
        pricingProfile: action.payload
      };
    case PaymentAction.SET_PRICING_TIME:
      return {
        ...state,
        pricingTime: action.payload
      };
    case PaymentAction.SET_PAYMENT_DETAIL:
      return {
        ...state,
        paymentDetail: action.payload
      };
    case PaymentAction.SET_PAYMENT_LOADER:
      const name = action.payload.name;
      const value = action.payload.value;
      const paymentLoader = state.paymentLoader;
      paymentLoader[name] = value;
      return {
        ...state,
        paymentLoader: paymentLoader
      };
  }
  return state;
}

